import { render } from "./ContentText.vue?vue&type=template&id=1afa2027"
import script from "./ContentText.vue?vue&type=script&lang=js"
export * from "./ContentText.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__